<template>
  <div id="app">
    <Navbar v-if="!isImPage"/>

    <router-view/>

    <Footer v-if="!isImPage"/>
  </div>
</template>
<script>
import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';

export default {
  components: {
    Navbar,
    Footer,
  },
  computed: {
    isImPage() {
      return this.$route.path === '/im' || this.$route.path === '/';
    }
  },
  mounted() {
    // 在mounted钩子中执行 JavaScript 代码，设置聊天机器人配置
    window.difyChatbotConfig = {
      token: 'ToEcfThfGX4y9GDb',
      baseUrl: 'http://api.servebot.ai'
    };

    const script = document.createElement('script');
    script.src = "http://api.servebot.ai/embed.min.js";
    script.id = "ToEcfThfGX4y9GDb";
    script.defer = true;
    document.body.appendChild(script);
  }
}
</script>

<style>
@font-face {
  font-family: 'YuGothic';
  src: url('./assets/fonts/yugothic-0-2.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Hiragino Kaku Gothic Std';
  src: url('./assets/fonts/Hiragino Kaku Gothic StdN W8.otf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

/* 全局样式 */
#app {
  font-family: "YuGothic", "Microsoft YaHei", Arial, "Meiryo", sans-serif;
  margin: 0;
  padding: 0;
}

h2 {
  font-family: 'Hiragino Kaku Gothic Std';
}

h3 {
  font-family: 'Hiragino Kaku Gothic Std';
}

#dify-chatbot-bubble-button {
  background-color: #1C64F2 !important;
}

#dify-chatbot-bubble-window {
  width: 24rem !important;
  height: 40rem !important;
}
</style>
